import IconSubmit from '@assets/icons/check.svg?react';
import { Box, Button, CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { Dispatch, MutableRefObject, SetStateAction, useMemo } from 'react';
import { FormProvider } from 'react-hook-form';

import { CustomGridApi, TableModalState } from '../XTable/types';
import EditFields from './EditFields';
import useEditForm from './useEditForm';

const EditForm = ({
 handleClose,
 modalState,
 setModalState,
 setCreateModalOpen,
 isOpen,
 apiRef,
 activeTabName,
}: {
 handleClose: () => void;
 modalState: TableModalState | undefined;
 setModalState: Dispatch<SetStateAction<TableModalState>>;
 setCreateModalOpen: Dispatch<SetStateAction<boolean>>;
 isOpen: boolean;
 apiRef: MutableRefObject<CustomGridApi>;
 activeTabName?: string;
}) => {
 const {
  handleSubmit,
  onSubmit,
  formMethods,
  isCreate,
  isDuplicate,
  structure,
  loading,
  submitDisabled,
  fieldsWithData,
  hasFieldsConfig,
  item,
 } = useEditForm({
  handleClose,
  modalState,
  setModalState,
  setCreateModalOpen,
  isOpen,
  apiRef,
  activeTabName,
 });
 //  console.log('fieldsWithData', fieldsWithData);
 const isMoreThanOneTab = useMemo(
  () =>
   structure?.filter(
    (field) => field.Type === 'array' || field.Group?.indexOf('_') !== -1,
   ).length > 0,
  [structure, item],
 );

 return (
  <Box
   sx={{
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
   }}
  >
   <Box
    sx={{
     overflow: 'hidden',
     overflowY: 'auto',
     height: isMoreThanOneTab ? 'calc(100% - 112px)' : '100%',
     pr: 1,
    }}
   >
    <FormProvider {...formMethods}>
     <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
      sx={{
       display: 'flex',
       flexDirection: 'column',
       gap: 2,
       mt: 0,
      }}
     >
      {!loading?.getItem && structure && (
       <Box sx={{}}>
        <EditFields
         fieldsWithData={fieldsWithData}
         activeTabName={activeTabName}
        />
       </Box>
      )}
     </Box>
    </FormProvider>
   </Box>
   <Box sx={{ gap: 2, display: 'flex', justifyContent: 'flex-end', pt: 3 }}>
    <Box
     sx={{ fontSize: 10, color: 'gray', width: 200, wordBreak: 'break-all' }}
    >
     {/* {JSON.stringify(isFormChanged)} */}
    </Box>
    <Button
     type="button"
     onClick={() => handleSubmit(onSubmit)()}
     variant="contained"
     color="primary"
     sx={{ width: 'auto' }}
     disabled={submitDisabled}
     endIcon={
      loading?.createItem || loading?.updateItem ? (
       <CircularProgress sx={{ color: 'white ' }} size={20} />
      ) : (
       <IconSubmit style={{ color: 'white', width: '16px', height: '11px' }} />
      )
     }
    >
     {isCreate || isDuplicate ? t('global.create') : t('global.save')}
    </Button>
   </Box>
  </Box>
 );
};
EditForm.displayName = 'EditForm';
export default EditForm;

